
export class SynthesisViewConfig {
  name: string;
  enabled: boolean;
  isDefault: boolean;
}
